import { axiosInstance as axios } from "../../../service/axiosManager"

const API_URL = process.env.REACT_APP_HOST_API + "/terminal-outputs"

// Helper to structure the data before sending
export const createLogObject = (userId, sessionId, outputArray, codeSnapshot=null) => {
  return {
    user_id: userId,
    session_id: sessionId,
    output: outputArray,
    code_context: codeSnapshot
  }
}

export const saveTerminalLog = async (logData) => {
  try {
    const response = await axios.post(API_URL, {
      terminal_output: logData 
    })
    return response.data
  } catch (error) {
    console.error("Error saving terminal log:", error)
    return null
  }
}

export const getUserTerminalLogs = async (sessionId, userId) => {
  if (!sessionId || !userId) return []

  try {
    const response = await axios.get(`${API_URL}/${sessionId}/${userId}`)
    return response.data.terminal_outputs || []
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getSessionTerminalLogs = async (sessionId) => {
  if (!sessionId) return []

  try {
    const response = await axios.get(`${API_URL}/session/${sessionId}`)
    return response.data.terminal_outputs || []
  } catch (error) {
    console.error(error)
    return []
  }
}

export const getTerminalLogById = async (logId) => {
  if (!logId) return null

  try {
    const response = await axios.get(`${API_URL}/${logId}`)
    return response.data.terminal_output
  } catch (error) {
    console.error(error)
    return null
  }
}